import {
  createBrowserRouter,
  createHashRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { authRoutes } from './modules/auth/auth-routes';
import { subscriptionRoutes } from './modules/subscription/subscription-routes';
import { AuthGuard } from './core/middleware';
import { NotFoundPage, NotAuthorizedPage } from './core/pages';
import { useDevice } from './core/hooks/useDevice';

const routes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <Navigate to='/subscription/plan' />
      </AuthGuard>
    ),
  },
  ...authRoutes,
  ...subscriptionRoutes,
  // Specific error pages
  {
    path: '/not-authorized',
    element: <NotAuthorizedPage />,
  },
  // Catch-all route for 404 page - must be last
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export const AppRouter = () => {
  const { isApp } = useDevice();
  const basePath = import.meta.env.VITE_BASE_URL;
  const router = isApp
    ? createHashRouter(routes)
    : createBrowserRouter(routes, { basename: basePath });

  return <RouterProvider router={router} />;
};
